import { Component } from '../component';
export class PortableComponent extends Component {
    constructor(name) {
        super(name);
        const portal = document.querySelector('cell-portal');
        if (!portal) {
            throw new Error('No portal found');
        }
        // Replace existing element if exists.
        const existingElement = portal.querySelector(`#${this.id}`);
        if (existingElement) {
            existingElement.replaceWith(this);
        }
        else {
            portal.appendChild(this);
        }
    }
}
